<template>
    <div class="job-details">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width">
            <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4">
                <!-- <div class="text-left mt-3 ml-5 mb-4">
          <a-icon class="mr-1" type="arrow-left" />
          <span class="go-back pointer" @click="goBack">Go Back</span>
        </div> -->

                <div v-if="loading" class="page-loader">
                    <hollow-dots-spinner
                        :animation-duration="1000"
                        :dot-size="15"
                        :dots-num="3"
                        color="#20409a"
                        class="mx-auto"
                    />
                </div>
                <div v-else class="row">
                    <div class="col-sm-12 col-md-12 col-lg-8">
                        <div v-if="project" class="row">
                            <div class="col d-flex">
                                <img :src="projectImage" class="project-logo mr-2" />
                                <div :class="!project.Name ? 'mt-n1' : 'mt-1'">
                                    <h4 class="font-weight-bolder mt-1 kova-text text-left">
                                        {{ project.Title }}
                                    </h4>
                                    <span class=" text-capitalize" style="color: rgb(254, 152, 22);">
                                        {{ (project.Name || '').toLowerCase() }}
                                    </span>
                                </div>
                            </div>
                            <div class="col text-right">
                                <h4 class="kova-text font-weight-bolder" v-if="project.StartBudget">
                                    {{ project.Currency }}{{ formatAmount(project.StartBudget) }} - {{ project.Currency
                                    }}{{ formatAmount(project.EndBudget) }}
                                </h4>
                                <h4 class="kova-text font-weight-bolder" v-else-if="project.Budget">
                                    {{ project.Currency }}{{ formatAmount(project.Budget) }}
                                </h4>
                            </div>
                        </div>

                        <div v-if="project">
                            <a-tabs defaultActiveKey="1">
                                <a-tab-pane tab="Details" key="1">
                                    <div class="bg-light border add-rounded p-4 mt-4">
                                        <div class="row">
                                            <div class="col-12 col-sm-12 col-md-9">
                                                <div class="row pl-3">
                                                    <div class=" d-flex">
                                                        <img :src="projectImage" class="project-logo mr-2" />
                                                        <h5 class="font-weight-bolder text-left mt-1">
                                                            {{ project.Title }}
                                                        </h5>
                                                    </div>
                                                    <!-- <a-tooltip placement="topLeft">
                              <template slot="title">
                                <span
                                  ><a-icon
                                    class="mr-2"
                                    type="info-circle"
                                    style="position:relative; bottom: 3px;font-size: 16px;"
                                  />click to copy</span
                                >
                              </template>
                              <span class="ml-2">
                                <div
                                  class="kova-id ml-3 text-white px-2 pointer"
                                  style="height: 20px"
                                >
                                  ID: {{ project.ID }}
                                </div>
                              </span>
                            </a-tooltip> -->
                                                </div>
                                                <div class="ml-5">
                                                    <h5 class="text-left mt-3 ctrl-size">Brief</h5>
                                                    <p class="text-left" v-html="projectDescription"></p>
                                                    <h5 class="text-left mt-3 ctrl-size">
                                                        Skills Required
                                                    </h5>
                                                    <div class="text-left d-flex flex-wrap">
                                                        <span
                                                            class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2 pointer text-capitalize"
                                                            v-for="skill in project.Skills"
                                                            :key="skill"
                                                        >
                                                            {{ skill }}</span
                                                        >
                                                    </div>
                                                    <h5 class="text-left mt-3 ctrl-size">Budgets</h5>
                                                    <div class="row pl-3">
                                                        <div>
                                                            <h4
                                                                class="text-left font-weight-bolder heading-text"
                                                                v-if="project.StartBudget"
                                                            >
                                                                {{ project.Currency
                                                                }}{{ formatAmount(project.StartBudget) }} -
                                                                {{ project.Currency
                                                                }}{{ formatAmount(project.EndBudget) }}
                                                            </h4>
                                                            <h4
                                                                class="text-left font-weight-bolder heading-text"
                                                                v-else-if="project.Budget"
                                                            >
                                                                {{ project.Currency }}{{ formatAmount(project.Budget) }}
                                                            </h4>
                                                        </div>
                                                        <!-- <div
                                class="ml-3 mt-2 incr-font-2 font-italic mb-3 mt-0"
                              >
                                $20.00/hr
                              </div> -->
                                                        <!-- <button class="btn-kovatek shadow py-2 px-3 px-md-4 btn-rounded ml-4 ml-md-5 pl-md-4">Enter Project Board</button> -->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-3">
                                                <div class="text-right font-weight-bolder">
                                                    <font-awesome-icon icon="clock" class="mr-2" />
                                                    {{ projectStatus }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="">
                                            <hr />
                                            <div class="row mt-2 text-left">
                                                <div class="col-4 mt-2">
                                                    <h6 class="font-weight-bolder ctrl-size-4">
                                                        {{ project.Specifications || 'Not Available' }}
                                                    </h6>
                                                    <p class="ctrl-size-2">Project Specification</p>
                                                </div>
                                                <div class="col-4 mt-2">
                                                    <h6 class="font-weight-bolder ctrl-size-4">
                                                        {{ hoursNeeded(project.Type) }}
                                                    </h6>
                                                    <p class="ctrl-size-2">Hours per week</p>
                                                </div>
                                                <div class="col-4 mt-2">
                                                    <h6 class="font-weight-bolder ctrl-size-4">
                                                        {{ projectDuration }}
                                                    </h6>
                                                    <p class="ctrl-size-2">Project Timeline</p>
                                                </div>
                                                <div class="col-4 mt-2">
                                                    <h6 class="font-weight-bolder ctrl-size-4">
                                                        {{ project.Invites }} of {{ project.TalentSize }} Hired
                                                    </h6>
                                                    <p class="ctrl-size-2">Developers to hire</p>
                                                </div>
                                                <div class="col-4 mt-2">
                                                    <h6 class="font-weight-bolder ctrl-size-4">
                                                        <font-awesome-icon
                                                            style="font-size: 14px;"
                                                            icon="map-marker-alt"
                                                            class="text-dark mr-1"
                                                        ></font-awesome-icon
                                                        >{{ projectLocation }}
                                                    </h6>
                                                    <p class="ctrl-size-2 ml-3">Location</p>
                                                </div>
                                                <div class="col-4 mt-2 d-none">
                                                    <h6 class="font-weight-bolder ctrl-size-4">
                                                        Interviewing: 6
                                                    </h6>
                                                    <p class="ctrl-size-2">Interview</p>
                                                </div>
                                            </div>
                                            <hr />
                                            <div>
                                                <h5 class="text-left ctrl-size">Specialization</h5>
                                                <div
                                                    class="text-left d-flex flex-wrap"
                                                    v-if="(project.Specializations || []).length"
                                                >
                                                    <span
                                                        class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2 mt-2"
                                                        v-for="skill in project.Specializations"
                                                        :key="skill"
                                                    >
                                                        {{ skill }}</span
                                                    >
                                                </div>
                                                <div class="text-left" v-else>
                                                    <p>There are no specializations for this job</p>
                                                </div>
                                            </div>
                                            <!-- <div class="">
                          <h5 class="text-left ctrl-size">Attached Files</h5>
                          <div class="text-left d-flex flex-wrap">
                            <button
                              class="btn-kovatek py-2 px-2 add-rounded ctrl-size-2"
                            >
                              <a-icon type="upload" /> Download
                            </button>
                          </div>
                        </div> -->
                                        </div>
                                    </div>

                                    <hr class="my-4" v-if="isProject" />
                                    <BidForm
                                        v-if="isProject"
                                        @bidding="getBidding"
                                        :isNew="isNewBidding"
                                        :data="data"
                                        :profileData="profileData"
                                    />

                                    <hr v-if="isProject" />
                                    <p class="error mb-0">{{ errorText }}</p>
                                    <div class="text-right my-4">
                                        <button
                                            class="btn-kovatek rounded px-4 py-2"
                                            @click="validateBid"
                                            v-if="isProject"
                                        >
                                            {{ isNewBidding ? 'Place Bid' : 'Update Bid' }}
                                        </button>
                                        <button v-else class="btn-kovatek rounded px-4 py-2" @click="apply">
                                            Apply For Job
                                        </button>
                                    </div>
                                </a-tab-pane>

                                <a-tab-pane tab="Applicants" key="2" forceRender>
                                    <div class="mt-4 mb-5">
                                        <div class="p-4 bg-light border shadow-sm add-rounded" v-if="proposals.length">
                                            <div :key="i" v-for="(work, i) in proposals">
                                                <applicant :applicant="work"></applicant>
                                                <hr v-if="i + 1 !== proposals.length" />
                                            </div>
                                        </div>
                                        <div class="p-4 bg-light text-center border shadow-sm add-rounded" v-else>
                                            <p>No one has applied for this job yet</p>
                                        </div>
                                    </div>
                                </a-tab-pane>
                            </a-tabs>
                        </div>

                        <div class="bg-light border add-rounded p-4 my-4" v-else>
                            <div class="row">
                                <div class="col-12">
                                    <a-skeleton active :paragraph="{ rows: 2 }" />
                                    <a-skeleton active :paragraph="{ rows: 2 }" />
                                    <hr />
                                    <a-skeleton active :paragraph="{ rows: 2 }" />
                                    <hr />
                                    <a-skeleton active :paragraph="{ rows: 2 }" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4 px-0 pt-lg-4 mt-lg-5">
                        <!-- {{ project }} -->
                        <div class="pt-1 ml-lg-4 mb-4" style="position: sticky; top:50px">
                            <PostedBy
                                :client="{
                                    ...clientData,
                                    logo: projectImage,
                                    Location: project ? `${project.City}, ${project.Country}` : '',
                                }"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a-modal v-model="showCalender" title="" onOk="handleOk" width="600px">
            <template slot="footer">
                <a-button key="submit" style="background-color:#20409a; color: #fff" @click="handleOk">
                    Ok
                </a-button>
            </template>
            <h4 class="font-weight-bolder text-center kova-text">
                Choose your delivery date
            </h4>
            <div class="">
                <p class="text-center">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    <span class="font-weight-bolder"></span>
                </p>
            </div>
            <div
                class="mx-auto"
                :style="{
                    width: '300px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                }"
            >
                <a-calendar :fullscreen="false" @select="onSelect" @panelChange="onPanelChange" />
            </div>
        </a-modal>
        <Footers />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footers from '@/components/Footer.vue';
import PostedBy from '@/components/PostedBy.vue';
import moment from 'moment';
import { computeStatus, computeDuration, computeLocation } from '@/helpers/compute.js';
import BidForm from '../components/projects/BidForm.vue';
import Applicant from '../components/projects/Applicant.vue';

export default {
    name: 'job-details',
    components: {
        Navbar,
        Footers,
        PostedBy,
        BidForm,
        Applicant,
    },
    data() {
        return {
            loading: true,
            skills: [],
            data: {},
            errorText: '',
            proposals: [],
            workHistory: [
                {
                    title: 'PHP / extJS / MVC Application Update',
                    duration: ' Mar 2016 - Sep 2018',
                    star: 5,
                    comment: 'Solid experience with PHP and extJS. Good quality work.',
                    earned: 963.34,
                    earnedPerHour: 20.0,
                    hours: 48,
                },
                {
                    title: 'ExtJS prototype development',
                    duration: 'Jul 2016 - Aug 2016',
                    star: 5,
                    comment: 'Nice job, completed on-time and high quality.',
                    earned: 560.0,
                    earnedPerHour: 30.0,
                    hours: 19,
                },
            ],
            proSkills: [],
            milestone: 0,
            project: null,
            showCalender: false,
            milestoneDate: new Date(),
            isNewBidding: false,
            bidding: {
                cover_letter: '',
                delivery_time: null,
                milestones: [],
            },
            profileData: {},
            clientData: {},
        };
    },
    methods: {
        async getProposals() {
            const { projectId } = this.$route.query;
            const token = localStorage.getItem('token');

            try {
                const res = await this.$api({
                    url: `/projects/${projectId}/biddings`,
                    method: 'get',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                this.proposals = res.data;
            } catch (err) {
                this.catchErrors(err);
                // console.log(err)
            }
        },
        async getClientData(id) {
            const token = localStorage.getItem('token');

            try {
                const res = await this.$api({
                    url: `/clients/profiles/${id}`,
                    method: 'get',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                this.clientData = res.data;
            } catch (err) {
                this.loading = false;
                this.catchErrors(err);
                // console.log(err)
            }
        },
        getBidding(bidding) {
            this.bidding = {
                ...this.bidding,
                ...bidding,
            };
        },
        editDate(index) {
            this.milestone = index;
            this.showCalender = true;
        },
        onSelect(value) {
            // this.date = value;
            this.data.milestones[this.milestone].due_date = moment(value)
                .format('dddd Do MMMM, YYYY')
                .toString();
            this.showCalender = false;
        },
        onPanelChange(value, mode) {
            console.log(value, mode);
        },
        goBack() {
            this.$router.go(-1);
        },
        handleOk() {
            this.showCalender = false;
        },
        checkforDuplicates: arr => arr.some((item, idx) => arr.indexOf(item) != idx),
        checkForEmptyFields(arr) {
            let count = 0;
            for (let key of arr) {
                if (!key.title || !key.amount || !key.details || !key.due_date) count += 1;
            }

            return count ? true : false;
        },
        validateBid() {
            this.errorText = '';
            const { cover_letter, total_amount, milestones, delivery_time } = this.bidding;

            if (!milestones.length) {
                this.errorText = 'You must have at least one milestone';
                return;
            }

            if (!cover_letter || !total_amount || !delivery_time) {
                let obj = { cover_letter, total_amount, delivery_time };
                for (let i in obj) {
                    if (obj[i]) return;
                    const div = document.querySelector(`#${i}`);
                    div.style.border = '1px dashed red';
                    document.querySelector('.placement').scrollIntoView();
                }
                return;
            }

            const emptyMilestones = this.checkForEmptyFields(milestones);
            if (emptyMilestones) {
                document.querySelector('#total_amount').scrollIntoView();
                this.errorText = "Please complete all the milestones' details";
                return;
            }

            if (milestones.length) {
                const total_mile_amount = milestones.map(a => a.amount).reduce((a, b) => a + b, 0);
                if (total_mile_amount !== total_amount) {
                    this.errorText = "The bill amount must be the total of all the milestones' amount";
                    return;
                }
            }

            this.bid(this.bidding);
        },
        apply() {
            const vm = this;

            this.$confirm({
                title: 'Are you sure?',
                content: 'You are applying for this job!',
                async onOk() {
                    return await confirmApplication();
                },
                onCancel() {},
            });

            async function confirmApplication() {
                const token = localStorage.getItem('token');
                const { projectId } = vm.$route.query;
                vm.loading = true;

                try {
                    await vm.$api({
                        url: `/projects/${projectId}/apply`,
                        method: 'post',
                        data: {},
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    await vm.getProposals();
                    vm.loading = false;

                    const text = 'The client will see your bid for this job';
                    vm.showNotification('success', text, 'Successful');

                    setTimeout(() => {
                        vm.$router.push('/proposals');
                    }, 3000);
                } catch (err) {
                    vm.loading = false;
                    vm.catchErrors(err);
                }
            }
        },
        bid(bidding) {
            const { projectId } = this.$route.query;
            const data = {
                projectId,
                bidding,
            };
            this.loading = true;

            if (this.isNewBidding) {
                this.$store
                    .dispatch('biddings/postBidding', data)
                    .then(() => {
                        const text = 'The client will see your bid for this job';
                        this.showNotification('success', text, 'Successful');
                    })
                    .catch(err => {
                        this.loading = false;
                        // console.log(err);
                        this.catchErrors(err);
                    });
            } else {
                this.$store
                    .dispatch('biddings/updateBidding', data)
                    .then(resp => {
                        console.log(resp);
                        this.loading = false;
                    })
                    .catch(err => {
                        // console.log(err);
                        this.loading = false;
                        this.catchErrors(err);
                    });
            }
        },
    },
    async mounted() {
        this.loading = true;
        this.$store.state.projects.projectId = this.$route.query.projectId;

        // let keyMap = {
        //   CoverLetter: 'cover_letter',
        //   DeliveryDays: 'delivery_time',
        //   Milestones: 'milestones',
        //   Title: 'title',
        //   Amount: 'amount',
        //   Due: 'due_date',
        //   // CreatedAt: "due_date"
        // };

        await this.$store
            .dispatch('projects/getProject', {
                projectId: this.$store.state.projects.projectId,
            })
            .then(async resp => {
                this.project = { ...resp.data };
                await Promise.all([
                    this.getProfile(),
                    this.getAllSettings(),
                    this.getProposals(),
                    this.getClientData(resp.data.ClientID),
                ]);
            })
            .catch(err => {
                this.loading = false;
                this.catchErrors(err);
            });
        this.loading = false;
    },
    computed: {
        projectStatus: function() {
            return computeStatus(this.project.Status);
        },
        projectDuration: function() {
            return computeDuration(this.project.Duration);
        },
        projectLocation: function() {
            return computeLocation(this.project.Location);
        },
        projectDescription() {
            const desc = this.project.Description;
            if (!desc) return '';
            return desc.charAt(0).toUpperCase() + desc.substr(1);
        },
        projectImage() {
            return this.project?.AvatarHref || this.companyLogo;
        },
        isProject() {
            return this.project.Type == 1 || this.project.Type == 4;
        },
    },
    filters: {
        moment: function(date) {
            return moment(date).format('MMMM Do YYYY, h:mm a');
        },
        dateOnly: function(date) {
            return moment(date).format('dddd Do MMMM, YYYY');
        },
        timeOnly: function(time) {
            return moment(time).format('h:mm a');
        },
    },
};
</script>
<style scoped>
.heading-text {
    font-size: 20px;
}

.kova-text {
    color: #20409a;
}
.add-rounded {
    border-radius: 10px;
}
.bg-skills {
    background-color: #4bb38e;
    color: #fff;
}
.incr-font-1 {
    font-size: 20px;
    font-style: italic;
}
.id {
    width: 100px;
    height: 20px;
    background-color: #4bb38e;
    border-radius: 5px;
}
.icon-size {
    font-size: 25px;
}
.bg-kovatek {
    background-color: #20409a;
}
.img-height {
    width: 90px;
    height: 90px;
}
.icon-env {
    font-size: 20px;
}
.ctrl-size {
    font-size: 16px;
}
.intermediate {
    color: rgb(148, 194, 20);
    font-size: 12px;
}
.ctrl-size-1 {
    font-size: 15px;
}
.ctrl-size-2 {
    font-size: 11px;
}
.text-size2 {
    font-size: 13px;
}
.ctrl-size-3 {
    font-size: 14px;
}
.ctrl-size-4 {
    font-size: 13px;
}
.rating {
    height: 15px;
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
    .employer-name {
        font-size: 18px;
    }
    .img-height {
        width: 70px;
        height: 70px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
}

@media screen and (max-width: 767px) {
    .float-text {
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6 {
        float: left;
    }
}
/* 
@media screen and (max-width: 550px){
    
} */

.error {
    color: #fc0404;
    float: left;
}
</style>
